import { computed, ref } from 'vue';
import { usePermission } from '@vueuse/core';
import { defineStore } from 'pinia';
import { useServiciosStore } from './servicios';

const getGeoAsync = (
  options = {
    enableHighAccuracy: true,
    maximumAge: 30e3,
    timeout: 27e3,
  }
) => {
  return new Promise((res, rej) =>
    navigator.geolocation.getCurrentPosition(
      (d) => res(d),
      (e) => rej(e),
      options
    )
  ).catch(() => ({
    coords: { latitude: Infinity, longitude: Infinity },
    timestamp: 0,
  })) as Promise<Partial<GeolocationPosition>>;
};

const BIOTREN_SERVS = ['biotren', 'laja-talcahuano'];
const BIOTREN_BASE_ST = 'concepcion';

export const geoStore = defineStore('geo', () => {
  const servicioStore = useServiciosStore();
  const geoAccess = usePermission('geolocation');
  const isGettingGeo = ref(false);

  const baseEstacion = computed(() => {
    if (BIOTREN_SERVS.includes(servicioStore.servicioActivo?.slug || '')) {
      return servicioStore.estaciones.get(BIOTREN_BASE_ST);
    } else {
      return Array.from(servicioStore.estaciones.values())[0];
    }
  });

  const baseCoords = computed(() => ({
    lat: baseEstacion.value?.lat,
    lng: baseEstacion.value?.lng,
  }));

  const coordsBase = ref({
    latitude: 0,
    longitude: 0,
  });
  const coords = computed(() => ({
    lat: coordsBase?.value.latitude || baseCoords.value.lat || 0,
    lng: coordsBase?.value.longitude || baseCoords.value.lng || 0,
  }));

  const hasGeolocationPermitted = () => {
    return geoAccess.value === 'granted';
  };
  const autoGetGeo = async () => {
    return hasGeolocationPermitted() && getSetGeo();
  };
  const getSetGeo = async () => {
    if (isGettingGeo.value) return;
    isGettingGeo.value = true;
    try {
      const geo = await getGeoAsync();

      coordsBase.value = {
        latitude: geo.coords?.latitude || 0,
        longitude: geo.coords?.longitude || 0,
      };

      return coords;
    } catch (error) {
      console.error('Error getting geolocation:', error);
      return null;
    } finally {
      isGettingGeo.value = false;
    }
  };

  return {
    coords,
    hasGeolocationPermitted,
    autoGetGeo,
    getSetGeo,
    baseEstacion,
    isGettingGeo: computed(() => isGettingGeo.value),
  };
});
